import React from 'react';

import { InfraContainer, InfraImage } from './InfraStyles';

// Swiper config
import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/scss';
import 'swiper/scss/pagination';


function InfraSlider({ mt, images }) {
    return (
        <InfraContainer mt={mt}>
            <Swiper
                modules={[ Pagination ]}
                slidesPerView={1}
                pagination={{ clickable: true }}
            >
                {
                    images.map( (image) => (
                        <SwiperSlide>
                            <InfraImage src={image} alt="Hiperracoes" />
                        </SwiperSlide>
                    ))
                }

            </Swiper>

        </InfraContainer>
    )
}

export default InfraSlider;